export default __webpack_public_path__ + "static/media/grey-pineapple.e7354836.svg";